import { formValidationSchema } from "@features/results/DownloadChartImageDialog/helpers"
import { yupResolver } from "@hookform/resolvers/yup"
import { Grid, TextField, Typography } from "@mui/material"
import { HTMLAttributes } from "react"
import { Controller, FormProvider, useForm } from "react-hook-form"
import { InferType } from "yup"

export type DownloadImageFormValues = InferType<typeof formValidationSchema>

type DownloadImageFormProps = Omit<HTMLAttributes<HTMLFormElement>, "onSubmit"> & {
  defaultValues: DownloadImageFormValues
  onSubmit: (values: DownloadImageFormValues) => void
}

const DownloadImageForm = ({ defaultValues, onSubmit, ...props }: DownloadImageFormProps) => {
  const methods = useForm<DownloadImageFormValues>({
    defaultValues,
    resolver: yupResolver(formValidationSchema),
  })

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = methods

  return (
    <FormProvider {...methods}>
      <form autoComplete="off" {...props} onSubmit={handleSubmit(onSubmit)}>
        <Grid container alignItems="center" sx={{ p: 2 }}>
          <Grid item xs>
            <Controller
              control={control}
              name="name"
              render={({ field }) => (
                <TextField
                  error={Boolean(errors[field.name])}
                  helperText={errors[field.name]?.message}
                  fullWidth
                  label="File name"
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs="auto">
            <Typography>.png</Typography>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  )
}

export default DownloadImageForm
